import { useEffect, useRef } from 'react';
import { Location, NavigationType, useLocation, useNavigationType } from 'react-router-dom';

const STORAGE_KEY = 'navigation_history';
let urls: string[] = [];

try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) {
        urls = JSON.parse(saved);
    }
} catch {
    /* empty */
}

const saveToStorage = () => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(urls));
    } catch {
        /* empty */
    }
};

export namespace History {
    export function push(url: string) {
        urls.push(url);
        saveToStorage();
    }

    export function pop() {
        urls.pop();
        saveToStorage();
    }

    export function getLast(): string {
        return urls[urls.length - 1];
    }

    export function getPrevious(): string | undefined {
        if (urls.length < 2) {
            return undefined;
        }

        return urls[urls.length - 2];
    }

    export function getAllUrls(): string[] {
        return [...urls];
    }
}

export const useLocationListener = () => {
    const location: Location = useLocation();
    const navType: NavigationType = useNavigationType();
    const isInitialRender = useRef(true);
    const previousLocationRef = useRef(location);

    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            // При инициализации добавляем текущий URL, если его еще нет в истории
            if (History.getLast() !== location.pathname) {
                History.push(location.pathname);
            }

            previousLocationRef.current = location;

            return;
        }

        if (navType === 'POP') {
            // Игнорируем POP при обновлении страницы
            if (History.getAllUrls().includes(location.pathname)) {
                // Реальный переход назад/вперед по истории
                while (History.getLast() !== location.pathname && History.getAllUrls().length > 0) {
                    History.pop();
                }
            }
        } else if (navType === 'PUSH' && location.pathname !== History.getLast()) {
            History.push(location.pathname);
        } else if (navType === 'REPLACE') {
            if (!previousLocationRef.current.state?.dialogName) {
                History.pop();
            }

            if (location.pathname !== History.getLast()) {
                History.push(location.pathname);
            }
        }

        previousLocationRef.current = location;
    }, [location, navType]);
};
